import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';

import { localStorageKey } from '../stores/slice/lang';
import { selectLangList, selectSelectedLang, langActions } from "../stores/slice/lang";

const useLang = () => {
  const { i18n } = useTranslation();
  const dispatch = useDispatch();
  const langList = useSelector(selectLangList);
  const selectedLang = useSelector(selectSelectedLang);

  const changeLang = (selectedLang) => {
    let updatedLangList = [];

    for (let originLang of langList) {
      let newLang = { ...originLang };

      newLang.isActive = false;
      newLang.id === selectedLang.id && (newLang.isActive = true);

      updatedLangList.push(newLang);
    }

    dispatch(langActions.changeLang(updatedLangList));
    i18n.changeLanguage(selectedLang.code);
    localStorage.setItem(localStorageKey, selectedLang.code);
  }

  return { langList, selectedLang, changeLang };
}

export default useLang;